import { ParallelTransform } from "../../../param/generalSearchTransform";
import { ListDefinition } from "../../../param/listDefinitionType";
import { progress } from "../generalSearchProgress";
import { Result } from "../generalSearchResult";
import { regexReplace } from "../regexReplace";

export const parallelTransform = async ({
  query,
  listDefinitionsTable,
  result,
  workerContext,
}: {
  query: ParallelTransform;
  listDefinitionsTable: Record<string, ListDefinition>;
  result: Result;
  workerContext: any;
}) => {
  progress.get().queryProgress[
    progress.get().queryProgress.length - 1
  ].totalWordCount = 0;

  const ret = [];
  for (const process of query.processes) {
    if (process.type === "regexReplace") {
      const list = await regexReplace(
        workerContext,
        process,
        listDefinitionsTable,
        result
      );
      ret.push(list);
    }
  }
  result = ret.flat();
  result.forEach((e) => {
    e.trace.push(e.currentWord);
  });
  return result;
};
